// 주가 데이터 가져오기

function fetchStockChartsData(ticker) {
  const BASE_URL = "https://financialmodelingprep.com/stable/historical-price-eod/full";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;
  const lastDate = new Date();
  lastDate.setFullYear(lastDate.getFullYear() - 3); // 3 year ago

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      from: lastDate.toISOString().split('T')[0],
    }
  )
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
}

function fetchStockDividendsData(ticker) {
  const BASE_URL = "https://financialmodelingprep.com/stable/dividends/";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
    }
  )
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
}

function fetchIncomeStatementData(ticker, period = "quarter") {
  const BASE_URL = "https://financialmodelingprep.com/stable/income-statement";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      period,
      limit: period === "annual" ? 10 : 20,
    }
  );
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function fetchBalanceSheetStatementData(ticker, period = "quarter") {
  const BASE_URL = "https://financialmodelingprep.com/stable/balance-sheet-statement";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      period,
      limit: period === "annual" ? 10 : 20,
    }
  );
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function fetchCashFlowStatementData(ticker, period = "quarter") {
  const BASE_URL = "https://financialmodelingprep.com/stable/cash-flow-statement";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      period,
      limit: period === "annual" ? 10 : 20,
    }
  );
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function fetchRevenueGeographicSegmentationData(ticker, period = "quarter") {
  const BASE_URL = "https://financialmodelingprep.com/stable/revenue-geographic-segmentation";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      period,
      limit: period === "annual" ? 10 : 20,
    }
  );
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

function fetchRevenueProductSegmentationData(ticker, period = "quarter") {
  const BASE_URL = "https://financialmodelingprep.com/stable/revenue-product-segmentation";
  const API_KEY = process.env.REACT_APP_FINANCIAL_API_KEY;

  const queryParams = new URLSearchParams(
    {
      symbol: ticker,
      apikey: API_KEY,
      period,
      limit: period === "annual" ? 10 : 40,
    }
  );
  const url = `${BASE_URL}?${queryParams.toString()}`;
  return fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export {
  fetchStockChartsData,
  fetchStockDividendsData,
  fetchIncomeStatementData,
  fetchBalanceSheetStatementData,
  fetchCashFlowStatementData,
  fetchRevenueGeographicSegmentationData,
  fetchRevenueProductSegmentationData,
};
